import axios from 'axios'

export default {
  namespaced: true,

  state: {
    cards: [],
    activeCard: {}
  },
  mutations: {
    set(state, cards) {
      state.cards = cards
    },
    activate(state, card) {
      const cards = state.cards
      cards.forEach(c => (c.active = false))
      // Use {} (not null) for "no selection" so the PaymentModal `disabled`
      // computed can safely read `.active` without crashing the render.
      if (!card) {
        state.activeCard = {}
        return
      }
      const activeCard = cards.find(c => c.paymentID === card.paymentID)
      if (!activeCard) {
        state.activeCard = {}
        return
      }
      activeCard.active = true
      state.activeCard = activeCard
    },
    reset(state) {
      state.cards = []
      state.activeCard = {}
    }
  },
  actions: {
    async fetch({commit}) {
      try {
        const url = process.env.VUE_APP_BACKEND
        const cards = await axios.get(url + '/users/payment')
        const changedCards = cards.data
        changedCards.forEach(card => (card.active = false))
        commit('set', changedCards)
      } catch (e) {
        commit('setError', e, {root: true})
        throw e
      }
    },
    async add({commit, dispatch, state}, token) {
      try {
        const url = process.env.VUE_APP_BACKEND
        const res = await axios.put(url + '/users/payment', token)
        await dispatch('fetch')
        // Auto-activate so the Pay button enables without the user having to
        // click their card row. Without this, third-party billers arriving cold
        // to the payment modal would add their card, see no error, then click
        // a silently-disabled Pay button and have no idea why nothing happens.
        // Activate the card that was JUST added (the backend returns its
        // paymentID; the card list is unordered, so cards[0] can be an old or
        // expired card). Preserve an existing selection; fall back to the
        // first card only if the response has no paymentID (older backend).
        if (!state.activeCard || !state.activeCard.active) {
          const newID = res.data && res.data.paymentID
          const added = newID && state.cards.find(c => c.paymentID === newID)
          const target = added || state.cards[0]
          if (target) commit('activate', target)
        }
      } catch (e) {
        commit('setError', e, {root: true})
        throw e
      }
    },
    async delete({commit, dispatch}, pm) {
      try {
        const url = process.env.VUE_APP_BACKEND
        await axios.delete(url + '/users/payment/' + pm)
        await dispatch('fetch')
      } catch (e) {
        commit('setError', e, {root: true})
        throw e
      }
    }
  },
  getters: {
    cards: s => s.cards
  }
}
